import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { BtText } from '@linqpal/components/src/ui'
import { ModalCloseIcon } from '../../../../../../assets/icons'

interface HeaderProps {
  title: string
  onClose?: () => void
}

export const Header: React.FC<HeaderProps> = ({ title, onClose }) => {
  return (
    <View style={styles.container}>
      <BtText style={styles.title}>{title}</BtText>
      <TouchableOpacity onPress={onClose}>
        <ModalCloseIcon width={40} height={40} />
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '94.5%',
    marginLeft: -15,
    marginBottom: 5,
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: '700',
    fontSize: 24,
    lineHeight: 34,
    letterSpacing: -0.5,
    color: '#001929',
    textAlign: 'left',
  },
})
